// Series derivation for multi-series charts, shared by the stacked_bar,
// grouped-bar, and multi-series line cases in ChartRenderer so they pivot
// identically.
//
// The agent emits flat rows of { label, value, segment }. A chart is
// multi-series when any row carries a non-null `segment`; each distinct segment
// is its own series (one <Bar> / <Line>). Recharts needs one object per x-axis
// `label` with a key per segment, so we pivot. Before this, the line case
// ignored `segment` entirely and plotted every row as a single series keyed on
// `label` — two rows sharing a month collapsed into one whipsawing line (BUG-8).
// The bar case had the same gap the other way: it ignored `segment` and plotted
// only `value`, so a paired trend (Raised vs Closed) lost its second series.
// A multi-series `bar` renders side-by-side GROUPED bars (no stackId) — a
// paired trend is a comparison, not a part-of-whole stack.

export function isMultiSeries(data) {
  return Array.isArray(data) && data.some((d) => d.segment !== null && d.segment !== undefined);
}

export function deriveSeries(data) {
  const segments = [...new Set(data.map((d) => d.segment))];
  const grouped = {};
  data.forEach((d) => {
    if (!grouped[d.label]) grouped[d.label] = { label: d.label };
    grouped[d.label][d.segment] = d.value;
  });
  return { segments, dataset: Object.values(grouped) };
}
